import { render, staticRenderFns } from "./ghTree.vue?vue&type=template&id=798060c8&scoped=true&"
import script from "./ghTree.vue?vue&type=script&lang=js&"
export * from "./ghTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798060c8",
  null
  
)

export default component.exports